import { hasTeaseImage, getTeaseUrl } from 'lib/teaseUtils';
import { getOptimizedImageUrl } from 'lib/imageUtils';
import AIMS_FLAVORS from 'lib/aimsFlavors';

/**
 * Determines if the current device is likely a touch-capable tablet or mobile.
 * @returns {boolean} True if the device is likely a touch tablet or mobile, false otherwise.
 */
export function isTouchSupportedDevice() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

/**
 * Returns the background picture URL for the video thumbnail.
 * @param {object} computedValues - The computed values from the video item.
 * @param {string} [vertical='news'] - The vertical type for the fallback image.
 * @returns {string} The optimized image URL for the background picture.
 */
export const getBackgroundPicture = (computedValues, vertical = 'news') => {
  const fallbackVerticalMap = {
    // eslint-disable-next-line max-len
    news: 'https://media4.s-nbcnews.com/i/newscms/2019_23/2887921/2x3_nbcnews_fallback_image_75962cb529381dae91e4953bf772b192.jpg',
  };
  if (computedValues && !hasTeaseImage(computedValues)) {
    Object.assign(computedValues, {
      alternateTeaseImages: [{
        aspectRatio: 'ASPECT_2X1',
        image: {
          altText: vertical,
          url: {
            primary: fallbackVerticalMap[vertical],
          },
        },
      }],
    });
  }
  const teaseUrl = getTeaseUrl({ computedValues });
  return getOptimizedImageUrl(teaseUrl, AIMS_FLAVORS.FOCAL_240x360, 'best', 2);
};

/**
 * Returns a wrapped index within bounds of a circular list.
 * @param {number} index The index to normalize
 * @param {number} length The length of the array/list
 */
export function getWrappedIndex(index, length) {
  return ((index % length) + length) % length;
}
